//
//
//
//
//
//
//
//
//

import { doOrder } from '@/https/prepareEnroll'

export default {

  data () {
    return {
      loading: false,
      payContent: '',
    }
  },

  async created () {
    await this.setPayContent()
  },

  methods: {
    async setPayContent () {
      this.loading = true
      const { data } = await doOrder({ pcdm: this.$route.query.pcdm })
      this.payContent = data.axfPage || ''

      this.loading = false
    },

  },
}
